<template>
  <!--begin::Content wrapper-->
  <div
    dir="rtl"
    class="modal fade forgetpassword-modal"
    id="lypay-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header">
          <h5 class="modal-title">خدمة LY Pay (الحوالات اليدوية)</h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> إغلاق
          </button>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <div class="support-box text-center">
            <img
              class="icon-img text-center"
              src="assets/img/ly-pay.png"
              style="width: 85px; height: 60px; margin: 0 auto"
              alt=""
            />
            <h4 class="pt-1" style="font-weight: 600">
              خدمة LY Pay (الحوالات اليدوية)
            </h4>
          </div>
          <!-- Loader -->
          <div v-if="isLoading" class="text-center p-5">
            <div class="spinner-border text-success" role="status">
              <span class="sr-only">جاري التحميل...</span>
            </div>
            <div class="mt-3">جاري التحميل...</div>
          </div>

          <!-- طلباتي -->
          <div v-else-if="showRequests">
            <h5 class="text-success mb-3 text-center">طلباتي السابقة</h5>
            <div
              v-if="myRequests.length === 0"
              class="alert alert-info text-center"
            >
              لا توجد طلبات بعد.
            </div>
            <table v-else class="table table-bordered text-center lypay-table">
              <thead class="thead-light">
                <tr>
                  <th>#</th>
                  <th>المصرف</th>
                  <th>المبلغ</th>
                  <th>الحالة</th>
                  <th>رقم العملية</th>
                  <th>تاريخ الإنشاء</th>
                  <th>تاريخ أخر تحديث</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="req in myRequests" :key="req.id">
                  <td>{{ req.id }}</td>
                  <td>{{ req.bank_name }}</td>
                  <td>{{ req.amount }}</td>
                  <td>
                    <span
                      v-if="req.status_value === 'pending'"
                      class="badge bg-warning text-dark"
                      >قيد المراجعة</span
                    >
                    <span
                      v-else-if="req.status_value === 'approved'"
                      class="badge bg-success"
                      >مقبول</span
                    >
                    <span
                      v-else-if="req.status_value === 'rejected'"
                      class="badge bg-danger"
                      >مرفوض</span
                    >
                    <span v-else class="badge bg-secondary">{{
                      req.status
                    }}</span>
                  </td>
                  <td>{{ req.bank_transaction_id || "-" }}</td>
                  <td style="font-size: 10px">{{ req.created_at }}</td>
                  <td style="font-size: 10px">{{ req.updated_at }}</td>
                </tr>
              </tbody>
            </table>

            <!-- ✅ Pagination -->
            <!-- ✅ عرض روابط الصفحات دايمًا -->
            <!-- ✅ عرض روابط الصفحات دايمًا -->
            <nav aria-label="صفحات الطلبات">
              <ul class="pagination justify-content-center">
                <!-- السابق -->
                <li
                  class="page-item"
                  :class="{ disabled: !pagination.prev_page_url }"
                >
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="changePage(pagination.current_page - 1)"
                  >
                    السابق
                  </a>
                </li>

                <!-- الصفحات -->
                <li
                  v-for="link in pagination.links"
                  :key="link.label"
                  class="page-item"
                  :class="{ active: link.active, disabled: !link.url }"
                >
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="changePageFromLink(link.url)"
                  >
                    <!-- ✅ تحويل اللينكات للغة العربية -->
                    <span v-if="link.label.includes('Previous')"> << </span>
                    <span v-else-if="link.label.includes('Next')"> >> </span>
                    <span v-else v-html="link.label"></span>
                  </a>
                </li>

                <!-- التالي -->
                <li
                  class="page-item"
                  :class="{ disabled: !pagination.next_page_url }"
                >
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="changePage(pagination.current_page + 1)"
                  >
                    التالي
                  </a>
                </li>
              </ul>
            </nav>

            <div class="text-center mt-3">
              <button class="btn btn-secondary" @click="backToBanks">
                <i class="fa fa-arrow-right"></i> رجوع للمصارف
              </button>
            </div>
          </div>

          <!-- Banks list -->
          <div v-else-if="!selectedBank">
            <!-- زر طلباتي -->
            <div class="text-end mb-3">
              <button class="btn btn-success btn-sm" @click="getMyRequests()">
                <i class="fa fa-list"></i> طلباتي
              </button>
            </div>

            <div class="row">
              <div v-for="bank in banks" :key="bank.id" class="col-md-4 mb-3">
                <div
                  class="card bank-card h-100 text-center"
                  @click="selectBank(bank)"
                >
                  <img
                    :src="bank.logo_url"
                    class="bank-logo mt-3"
                    :alt="bank.bank_name"
                  />
                  <div class="card-body">
                    <h6 class="bank-name">{{ bank.bank_name }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Selected Bank Details -->
          <div v-else-if="!stepConfirm">
            <div class="card shadow-sm p-3">
              <h5 class="text-success mb-3 text-center">
                بيانات التحويل - {{ selectedBank.bank_name }}
              </h5>
              <p class="text-muted text-center mb-3">
                {{ selectedBank.note }}
              </p>

              <div class="text-center">
                <!-- QR Code -->
                <img
                  v-if="qrCodeDataUrl"
                  :src="qrCodeDataUrl"
                  alt="QR Code"
                  class="qr-code mb-3"
                />

                <!-- IBAN or Account -->
                <div class="alert border shadow-sm">
                  <strong style="text-dark">
                    {{ selectedBank.iban ? "IBAN" : "رقم الحساب" }}:
                  </strong>
                  <span class="text-primary">
                    {{ selectedBank.iban || selectedBank.account_number }}
                  </span>
                  <button
                    class="btn btn-light ml-2 text-dark"
                    @click="copyAccountNumber"
                  >
                    <i style="font-size: 20px" class="fa fa-copy"></i>
                  </button>
                </div>
                <transition name="fade">
                  <span
                    v-if="copied"
                    class="fixed bottom-4 right-4 bg-green-600 text-green px-4 py-2 rounded-lg shadow-md"
                  >
                    تم نسخ رقم الحساب
                  </span>
                </transition>
              </div>

              <!-- زر الانتقال للخطوة الثالثة -->
              <div class="text-center mt-3">
                <button class="btn btn-success" @click="stepConfirm = true">
                  <i class="fa fa-check"></i> لقد قمت بالتحويل
                </button>
              </div>

              <div class="text-center mt-3">
                <button class="btn btn-secondary" @click="backToBanks">
                  <i class="fa fa-arrow-right"></i> رجوع للمصارف
                </button>
              </div>
            </div>
          </div>

          <!-- Form لتأكيد العملية -->
          <div v-else>
            <div class="card shadow-sm p-4">
              <h5 class="text-success mb-3 text-center">
                تأكيد التحويل - {{ selectedBank.bank_name }}
              </h5>

              <form @submit.prevent="submitRequest">
                <div class="form-group mb-3">
                  <label>الاسم الكامل</label>
                  <input
                    type="text"
                    v-model="form.user_full_name"
                    class="form-control"
                    required
                  />
                </div>

                <div class="form-group mb-3">
                  <label>المبلغ</label>
                  <input
                    type="number"
                    v-model="form.amount"
                    class="form-control"
                    required
                  />
                </div>

                <div class="d-flex justify-content-between">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="stepConfirm = false"
                  >
                    <i class="fa fa-arrow-right"></i> رجوع
                  </button>
                  <button
                    type="submit"
                    class="btn btn-success"
                    :disabled="submitting"
                  >
                    <span v-if="submitting">
                      <i class="fa fa-spinner fa-spin"></i> جاري الإرسال...
                    </span>
                    <span v-else>
                      <i class="fa fa-check"></i> تأكيد التحويل
                    </span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            إغلاق
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--end::Content wrapper-->
</template>

<script>
import { apiUrl } from "@/utils/api";
import QRCode from "qrcode";
import Swal from "sweetalert2";

export default {
  name: "Academia",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      banks: [],
      copied: false,
      selectedBank: null,
      qrCodeDataUrl: null,
      isLoading: false,
      stepConfirm: false,
      submitting: false,
      showRequests: false,
      myRequests: [],
      pagination: {
        current_page: 1,
        last_page: 1,
        next_page_url: null,
        prev_page_url: null,
        links: [],
      },
      form: {
        user_full_name: "",
        amount: "",
      },
    };
  },
  mounted() {
    $("#lypay-modal").on("show.bs.modal", () => {
      this.getBanks();
      const myModal = new bootstrap.Modal(
        document.getElementById("payments-modal")
      );
      myModal.hide();
    });
  },
  methods: {
    async getBanks() {
      this.isLoading = true;
      this.selectedBank = null;
      this.qrCodeDataUrl = null;
      this.stepConfirm = false;
      this.showRequests = false;
      try {
        const response = await fetch(`${apiUrl}/lypay/banks`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        });
        if (!response.ok) throw await response.json();
        const data = await response.json();
        this.banks = data.data;
      } catch (error) {
        console.error("خطأ في جلب المصارف:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async getMyRequests(page = 1) {
      this.isLoading = true;
      this.showRequests = true;
      this.selectedBank = null;
      this.stepConfirm = false;
      try {
        const response = await fetch(
          `${apiUrl}/lypay/my-requests?page=${page}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
          }
        );
        if (!response.ok) throw await response.json();
        const data = await response.json();
        this.myRequests = data.data;
        this.pagination = {
          current_page: data.meta.current_page,
          last_page: data.meta.last_page,
          next_page_url: data.links.next,
          prev_page_url: data.links.prev,
          links: data.meta.links,
        };
      } catch (error) {
        console.error("خطأ في جلب الطلبات:", error);
      } finally {
        this.isLoading = false;
      }
    },
    getPageNumber(url) {
      const params = new URL(url).searchParams;
      return params.get("page");
    },
    async copyAccountNumber() {
      try {
        await navigator.clipboard.writeText(this.selectedBank.account_number);
        this.copied = true;
        setTimeout(() => (this.copied = false), 2000);
      } catch (err) {
        console.error("فشل النسخ:", err);
      }
    },
    async selectBank(bank) {
      this.selectedBank = bank;
      this.qrCodeDataUrl = null;
      this.stepConfirm = false;

      const text = bank.iban || bank.account_number;
      if (text) {
        try {
          this.qrCodeDataUrl = await QRCode.toDataURL(text, {
            width: 200,
            margin: 2,
          });
        } catch (err) {
          console.error("فشل في توليد QR:", err);
        }
      }
    },
    backToBanks() {
      this.selectedBank = null;
      this.qrCodeDataUrl = null;
      this.stepConfirm = false;
      this.showRequests = false;
    },
    async submitRequest() {
      if (!this.form.user_full_name || !this.form.amount) return;

      const confirmResult = await Swal.fire({
        title: "هل أنت متأكد؟",
        text: "سيتم إرسال طلبك للمراجعة",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "نعم، أرسل الطلب",
        cancelButtonText: "إلغاء",
      });

      if (!confirmResult.isConfirmed) return;

      this.submitting = true;
      try {
        const response = await fetch(`${apiUrl}/lypay/submit-request`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
          body: JSON.stringify({
            bank_id: this.selectedBank.id,
            user_full_name: this.form.user_full_name,
            amount: this.form.amount,
          }),
        });

        const result = await response.json();
        if (!response.ok) throw result;

        Swal.fire({
          icon: "success",
          title: "تم استلام طلبك بنجاح",
          text: "الطلب قيد المراجعة سيتم اعلامك فور الموافقة عليه",
        });

        this.backToBanks();
      } catch (error) {
        Swal.fire(
          "خطأ في ارسال الطلب يرجى التأكد واعادة المحاولة",
          "",
          "error"
        );
        console.error("خطأ في الإرسال:", error);
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.bank-card {
  cursor: pointer;
  border: 2px solid #eee;
  border-radius: 12px;
  transition: all 0.3s ease-in-out;
}
.bank-card:hover {
  border-color: #00c444;
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 196, 68, 0.2);
}
.bank-logo {
  max-height: 70px;
  object-fit: contain;
}
.bank-name {
  font-weight: 600;
  font-size: 14px;
}
.qr-code {
  width: 200px;
  height: 200px;
  margin: auto;
  display: block;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
